import React from 'react'
import { connect } from 'react-redux'
import { v4 as uuid } from 'uuid'
import CurrencyInput from 'react-currency-input'
import Select from 'react-select'

import Titulo from '../comum/Titulo'
import buscarItinerariosAbertosVendaUrbana from '../../actions/vendaUrbana/buscarItinerariosAbertosVendaUrbana'
import cadastrarVendaUrbana from '../../actions/vendaUrbana/cadastrarVendaUrbana'
import buscarVendaUrbanaPorId from '../../actions/vendaUrbana/buscarVendaUrbanaPorId'
import buscarCidadesPorNome from '../../actions/cidade/buscarCidadesPorParte'
import recuperarFormaPagamentosDesativados from '../../actions/forma-pagamento/recuperarFormaPagamentosDesativados'
import recuperarPagamentosDesativadosUsuario from '../../actions/forma-pagamento/recuperarPagamentosDesativadosUsuario'
import { salvarVendaUrbanaOffline } from '../../util/offlineStorage'
import { sincronizarVendasUrbanasOffline } from '../../util/offlineSyncManagerVendaUrbana'
import { tamanhoArquivoUpload } from '../../util/applicationContext'
import { showErrorMsg } from '../../util/messagesUtil'

const FORMAS_COM_COMPROVANTE = ['CARTAO_CREDITO', 'CARTAO_DEBITO', 'PIX']
const FORMAS_COM_PARCELAS = ['CARTAO_CREDITO', 'CARTAO_DEBITO']

const VALOR_MINIMO = 7

// Ícones validados contra node_modules/material-design-icons/iconfont/codepoints
// (qr_code, payments e receipt_long não existem nessa versão do pacote e renderizavam glifos quebrados)
const FORMAS_PAGAMENTO = [
  { codigo: 'DINHEIRO', label: 'Dinheiro', icone: 'local_atm', cor: 'green', hex: '#28a745' },
  { codigo: 'PIX', label: 'PIX', icone: 'flash_on', cor: 'teal', hex: '#20c997' },
  { codigo: 'CARTAO_CREDITO', label: 'Cartão de Crédito', icone: 'credit_card', cor: 'blue', hex: '#007bff' },
  { codigo: 'CARTAO_DEBITO', label: 'Cartão de Débito', icone: 'credit_card', cor: 'purple', hex: '#6f42c1' }
]

function parseValor (valor) {
  if (!valor) return NaN
  const limpo = valor.toString().replace('R$', '').trim()
  return parseFloat(limpo.replace(/\./g, '').replace(',', '.'))
}

function formatarItinerario (it) {
  return `${it.descricaoRota} | ${it.cidadeOrigem} -> ${it.cidadeDestino} | ${it.dataHoraPartida} | ${it.status}`
}

function formatarCidade (cidade) {
  return `${cidade.nome}-${cidade.uf}`
}

const opcaoItinerario = it => ({ value: it.id, label: formatarItinerario(it), raw: it })
const opcaoCidade = cidade => ({ value: cidade.id, label: formatarCidade(cidade), raw: cidade })

export class PainelCadastroVendaUrbana extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      itinerarioSelecionado: null,
      nomePassageiro: '',
      rg: '',
      cidadeOrigem: null,
      opcoesCidadeOrigem: [],
      cidadeDestino: null,
      opcoesCidadeDestino: [],
      valor: '',
      formasPagamentoSelecionadas: [],
      valoresPorForma: {},
      comprovantesPorForma: {},
      observacao: '',
      erros: {},
      pagamentoTocado: false,
      salvando: false,
      erroSalvar: null,
      vendaCriada: null,
      vendaEnfileirada: false
    }
  }

  componentDidMount () {
    const idEmpresa = this.props.empresaSelecionada.id
    this.props.buscarItinerariosAbertosVendaUrbana(idEmpresa)
    this.props.recuperarFormaPagamentosDesativados(idEmpresa)
    this.props.recuperarPagamentosDesativadosUsuario(idEmpresa)
  }

  buscarCidades (valor, campoOpcoes) {
    if (!valor || valor.trim().length < 3) {
      this.setState({ [campoOpcoes]: [] })
      return
    }
    this.props.buscarCidadesPorNome(valor).then(resp => {
      this.setState({ [campoOpcoes]: (resp.payload && resp.payload.data) || [] })
    })
  }

  formaPagamentoDesabilitada (codigo) {
    const desativadas = (this.props.pagamentosDesativados && this.props.pagamentosDesativados.pagamentosDesativados) || []
    const desativadasUsuario = (this.props.pagamentosDesativadosUsuario && this.props.pagamentosDesativadosUsuario.pagamentosDesativadosUsuario) || []
    return desativadas.includes(codigo) || desativadasUsuario.includes(codigo)
  }

  togglePagamento (codigo) {
    const selecionadas = this.state.formasPagamentoSelecionadas
    const valores = { ...this.state.valoresPorForma }

    if (selecionadas.includes(codigo)) {
      delete valores[codigo]
      this.setState({
        formasPagamentoSelecionadas: selecionadas.filter(c => c !== codigo),
        valoresPorForma: valores,
        pagamentoTocado: true
      })
      return
    }

    const novasSelecionadas = [...selecionadas, codigo]
    // primeira forma marcada assume o valor total da reserva; ao dividir, o usuário ajusta manualmente
    if (selecionadas.length === 0) {
      valores[codigo] = this.state.valor || ''
    }
    this.setState({ formasPagamentoSelecionadas: novasSelecionadas, valoresPorForma: valores, pagamentoTocado: true })
  }

  atualizarValorForma (codigo, valor) {
    this.setState({ valoresPorForma: { ...this.state.valoresPorForma, [codigo]: valor } })
  }

  atualizarComprovanteCampo (codigo, campo, valor) {
    const comprovante = { ...(this.state.comprovantesPorForma[codigo] || {}), [campo]: valor }
    this.setState({ comprovantesPorForma: { ...this.state.comprovantesPorForma, [codigo]: comprovante } })
  }

  handleAnexarComprovante (event, codigo) {
    const file = event.target.files && event.target.files[0]
    if (!file) return
    if (!/\.(jpe?g|png|pdf)$/i.test(file.name)) return
    if (file.size > tamanhoArquivoUpload) {
      showErrorMsg('Tamanho do arquivo excede 20 MB')
      return
    }
    const reader = new FileReader()
    reader.onload = () => {
      const comprovante = { ...(this.state.comprovantesPorForma[codigo] || {}), base64Comprovante: reader.result, nomeComprovante: file.name }
      this.setState({ comprovantesPorForma: { ...this.state.comprovantesPorForma, [codigo]: comprovante } })
    }
    reader.readAsDataURL(file)
  }

  removerComprovante (codigo) {
    const comprovante = { ...(this.state.comprovantesPorForma[codigo] || {}), base64Comprovante: null, nomeComprovante: null }
    this.setState({ comprovantesPorForma: { ...this.state.comprovantesPorForma, [codigo]: comprovante } })
  }

  somaValoresFormasPagamento () {
    return this.state.formasPagamentoSelecionadas.reduce((soma, codigo) => {
      const valor = parseValor(this.state.valoresPorForma[codigo])
      return soma + (isNaN(valor) ? 0 : valor)
    }, 0)
  }

  validar () {
    const erros = {}
    if (!this.state.itinerarioSelecionado) erros.itinerario = 'Selecione um itinerário aberto.'
    if (!this.state.nomePassageiro.trim()) erros.nomePassageiro = 'Informe o nome do passageiro.'
    if (!this.state.rg.trim()) erros.rg = 'Informe o RG.'
    if (!this.state.cidadeOrigem) erros.cidadeOrigem = 'Selecione a cidade de origem.'
    if (!this.state.cidadeDestino) erros.cidadeDestino = 'Selecione a cidade de destino.'
    const valorNumerico = parseValor(this.state.valor)
    if (isNaN(valorNumerico) || valorNumerico < VALOR_MINIMO) {
      erros.valor = 'O valor mínimo para venda urbana é R$ 7,00.'
    }

    if (this.state.formasPagamentoSelecionadas.length === 0) {
      erros.formaPagamento = 'Selecione ao menos uma forma de pagamento.'
    } else {
      const algumValorInvalido = this.state.formasPagamentoSelecionadas.some(codigo => {
        const valor = parseValor(this.state.valoresPorForma[codigo])
        return isNaN(valor) || valor <= 0
      })
      if (algumValorInvalido) {
        erros.formaPagamento = 'Informe o valor de cada forma de pagamento selecionada.'
      } else if (!isNaN(valorNumerico) && Math.abs(this.somaValoresFormasPagamento() - valorNumerico) > 0.01) {
        erros.formaPagamento = 'A soma dos valores das formas de pagamento deve ser igual ao valor da reserva.'
      }
    }

    this.setState({ erros })
    return Object.keys(erros).length === 0
  }

  finalizarVenda () {
    if (this._enviando) return
    this._enviando = true

    if (!this.validar()) { this._enviando = false; return }
    if (this.state.salvando) { this._enviando = false; return }

    const idEmpresa = this.props.empresaSelecionada.id
    const valorLimpo = this.state.valor.toString().replace('R$', '').trim()
    const comando = {
      empresaId: idEmpresa,
      itinerarioId: this.state.itinerarioSelecionado.id,
      nomePassageiro: this.state.nomePassageiro,
      rg: this.state.rg,
      cidadeOrigemId: this.state.cidadeOrigem.id,
      cidadeDestinoId: this.state.cidadeDestino.id,
      valor: valorLimpo,
      observacao: this.state.observacao,
      formasPagamento: this.state.formasPagamentoSelecionadas.map(codigo => {
        const comprovante = this.state.comprovantesPorForma[codigo] || {}
        return {
          codigoTipo: codigo,
          valor: parseValor(this.state.valoresPorForma[codigo]),
          numeroComprovante: comprovante.numeroComprovante || null,
          quantidadeParcelas: comprovante.quantidadeParcelas || null,
          base64Comprovante: comprovante.base64Comprovante || null,
          nomeComprovante: comprovante.nomeComprovante || null
        }
      })
    }

    this.setState({ salvando: true, erroSalvar: null })

    if (!navigator.onLine) {
      this.enfileirarOffline(comando)
      return
    }

    this.props.cadastrarVendaUrbana(comando).then(id => {
      this.props.buscarVendaUrbanaPorId(id, idEmpresa)
      this._enviando = false
      this.setState({ salvando: false, vendaCriada: id })
    }).catch(erro => {
      if (!erro.response) {
        // falha de rede (sem resposta do servidor) — enfileira para sincronizar depois
        this.enfileirarOffline(comando)
        return
      }
      const mensagem = (erro.response && erro.response.data && erro.response.data.message) || 'Não foi possível concluir a venda urbana.'
      this._enviando = false
      this.setState({ salvando: false, erroSalvar: mensagem })
    })
  }

  enfileirarOffline (comando) {
    const idChaveOffline = uuid()
    salvarVendaUrbanaOffline({
      idChaveOffline,
      dadosVenda: comando,
      nomePassageiro: comando.nomePassageiro,
      valorTotal: parseValor(comando.valor),
      // campos abaixo são só para exibição na listagem de vendas urbanas offline —
      // dadosVenda (enviado ao servidor no sync) permanece só com os ids
      empresaNome: this.props.empresaSelecionada && this.props.empresaSelecionada.nome,
      cidadeOrigemNome: this.state.cidadeOrigem && formatarCidade(this.state.cidadeOrigem),
      cidadeDestinoNome: this.state.cidadeDestino && formatarCidade(this.state.cidadeDestino),
      itinerarioLabel: this.state.itinerarioSelecionado && formatarItinerario(this.state.itinerarioSelecionado)
    }).then(() => {
      sincronizarVendasUrbanasOffline()
      this._enviando = false
      this.setState({ salvando: false, vendaEnfileirada: true })
    })
  }

  novaVenda () {
    this.setState({
      itinerarioSelecionado: null,
      nomePassageiro: '',
      rg: '',
      cidadeOrigem: null,
      cidadeDestino: null,
      valor: '',
      formasPagamentoSelecionadas: [],
      valoresPorForma: {},
      comprovantesPorForma: {},
      observacao: '',
      erros: {},
      pagamentoTocado: false,
      vendaCriada: null,
      vendaEnfileirada: false
    })
  }

  renderInfoBox (texto) {
    return (
      <div className="vx-pay-attachment" style={{ height: '100%', alignItems: 'flex-start' }}>
        <i className="material-icons">info</i>
        <div className="vx-pay-attachment-name" style={{ fontWeight: 400 }}>{texto}</div>
      </div>
    )
  }

  renderResumoEnfileirada () {
    return (
      <div className="vx-modal-section">
        <div className="alert alert-info" role="alert">
          Sem conexão com a internet no momento. A venda urbana foi salva neste dispositivo e será
          enviada automaticamente assim que a conexão voltar.
        </div>
        <div className="form-row">
          <div className="col-md-4">
            <button className="vx-btn-secondary" style={{ width: '100%' }} onClick={() => this.novaVenda()}>
              Nova venda urbana
            </button>
          </div>
          <div className="col-md-4">
            <button className="vx-btn-secondary" style={{ width: '100%' }}
                    onClick={() => this.props.history.push('/painel-vendas-urbanas-offline')}>
              Ver vendas urbanas offline
            </button>
          </div>
          <div className="col-md-4">
            <button className="vx-btn-secondary" style={{ width: '100%' }}
                    onClick={() => this.props.history.push('/painel-vendas-urbanas')}>
              Ir para Gerenciar Vendas Urbanas
            </button>
          </div>
        </div>
      </div>
    )
  }

  renderResumoSucesso () {
    return (
      <div className="vx-modal-section">
        <div className="alert alert-success" role="alert">Venda urbana cadastrada com sucesso!</div>
        <div className="form-row">
          <div className="col-md-4">
            <button className="vx-btn-primary" style={{ width: '100%' }}
                    onClick={() => this.props.history.push('/recibo-venda-urbana')}>
              Imprimir cupom
            </button>
          </div>
          <div className="col-md-4">
            <button className="vx-btn-secondary" style={{ width: '100%' }} onClick={() => this.novaVenda()}>
              Nova venda urbana
            </button>
          </div>
          <div className="col-md-4">
            <button className="vx-btn-secondary" style={{ width: '100%' }}
                    onClick={() => this.props.history.push('/painel-vendas-urbanas')}>
              Ir para Gerenciar Vendas Urbanas
            </button>
          </div>
        </div>
      </div>
    )
  }

  render () {
    if (this.state.vendaCriada) {
      return (
        <div className="row internas">
          <Titulo texto="Vendas Urbanas" urlRetorno="/painel-vendas-urbanas"/>
          <div className="col-12">
            {this.renderResumoSucesso()}
          </div>
        </div>
      )
    }

    if (this.state.vendaEnfileirada) {
      return (
        <div className="row internas">
          <Titulo texto="Vendas Urbanas" urlRetorno="/painel-vendas-urbanas"/>
          <div className="col-12">
            {this.renderResumoEnfileirada()}
          </div>
        </div>
      )
    }

    const itinerarios = this.props.itinerariosAbertosVendaUrbana || []
    const formasSelecionadasInfo = FORMAS_PAGAMENTO.filter(f => this.state.formasPagamentoSelecionadas.includes(f.codigo))
    const valorReservaNumerico = parseValor(this.state.valor)
    const somaFormasPagamento = this.somaValoresFormasPagamento()
    const somaDivergente = formasSelecionadasInfo.length > 0 && !isNaN(valorReservaNumerico)
      && Math.abs(somaFormasPagamento - valorReservaNumerico) > 0.009
    const nenhumaFormaSelecionada = this.state.pagamentoTocado && formasSelecionadasInfo.length === 0

    return (
      <div className="row internas">
        <Titulo texto="Vendas Urbanas" urlRetorno="/painel-vendas-urbanas"/>

        <div className="col-12">
          <div className="row">
            <div className="col-md-8">
              <div className="vx-modal-section" style={{ height: '100%' }}>
                <div className="vx-modal-section-title">
                  <i className="material-icons">directions_bus</i> Selecionar itinerário aberto
                </div>
                <p className="text-muted" style={{ fontSize: 12, marginTop: -6 }}>
                  Pesquise e selecione um itinerário do dia ou um itinerário ainda não encerrado.
                </p>
                <label style={{ fontSize: 11, fontWeight: 700, color: '#FF6A00', textTransform: 'uppercase', letterSpacing: '.3px' }}>
                  Itinerário aberto
                </label>
                <Select
                  options={itinerarios.map(opcaoItinerario)}
                  value={this.state.itinerarioSelecionado ? opcaoItinerario(this.state.itinerarioSelecionado) : null}
                  onChange={opcao => this.setState({ itinerarioSelecionado: opcao ? opcao.raw : null })}
                  placeholder="Selecione ou pesquise um itinerário aberto..."
                  noOptionsMessage={() => 'Nenhum itinerário aberto encontrado'}
                  isClearable
                />
                {this.state.erros.itinerario && <small className="text-danger">{this.state.erros.itinerario}</small>}
              </div>
            </div>
            <div className="col-md-4">
              {this.renderInfoBox('A venda urbana é realizada selecionando um itinerário aberto. Apenas itinerários em aberto são exibidos.')}
            </div>
          </div>

          <div className="vx-modal-section">
            <div className="vx-modal-section-title">
              <i className="material-icons">person</i> Dados da venda
            </div>

            <div className="form-row">
              <div className="col-md-3">
                <label>Cidade origem</label>
                <Select
                  options={this.state.opcoesCidadeOrigem.map(opcaoCidade)}
                  value={this.state.cidadeOrigem ? opcaoCidade(this.state.cidadeOrigem) : null}
                  onChange={opcao => this.setState({ cidadeOrigem: opcao ? opcao.raw : null })}
                  onInputChange={valor => { this.buscarCidades(valor, 'opcoesCidadeOrigem'); return valor }}
                  filterOption={() => true}
                  placeholder="Digite a cidade de origem..."
                  noOptionsMessage={() => 'Digite ao menos 3 letras'}
                  isClearable
                />
                {this.state.erros.cidadeOrigem && <small className="text-danger">{this.state.erros.cidadeOrigem}</small>}
              </div>
              <div className="col-md-3">
                <label>Cidade destino</label>
                <Select
                  options={this.state.opcoesCidadeDestino.map(opcaoCidade)}
                  value={this.state.cidadeDestino ? opcaoCidade(this.state.cidadeDestino) : null}
                  onChange={opcao => this.setState({ cidadeDestino: opcao ? opcao.raw : null })}
                  onInputChange={valor => { this.buscarCidades(valor, 'opcoesCidadeDestino'); return valor }}
                  filterOption={() => true}
                  placeholder="Digite a cidade de destino..."
                  noOptionsMessage={() => 'Digite ao menos 3 letras'}
                  isClearable
                />
                {this.state.erros.cidadeDestino && <small className="text-danger">{this.state.erros.cidadeDestino}</small>}
              </div>
              <div className="col-md-3">
                <label>Nome do passageiro</label>
                <input type="text" className="form-control" value={this.state.nomePassageiro}
                       onChange={event => this.setState({ nomePassageiro: event.target.value })}/>
                {this.state.erros.nomePassageiro && <small className="text-danger">{this.state.erros.nomePassageiro}</small>}
              </div>
              <div className="col-md-3">
                <label>RG</label>
                <input type="text" className="form-control" value={this.state.rg}
                       onChange={event => this.setState({ rg: event.target.value })}/>
                {this.state.erros.rg && <small className="text-danger">{this.state.erros.rg}</small>}
              </div>
            </div>

            <div className="form-row mt-3">
              <div className="col-md-4 d-flex flex-column">
                <label>Valor da reserva (R$)</label>
                <CurrencyInput
                  prefix="R$" decimalSeparator=","
                  className="form-control"
                  thousandSeparator="."
                  value={this.state.valor}
                  onChange={valorFormatado => this.setState({ valor: valorFormatado })}
                />
                {this.state.erros.valor
                  ? <small className="text-danger">{this.state.erros.valor}</small>
                  : <small className="text-muted">Valor mínimo permitido: R$ 7,00</small>}
              </div>
              <div className="col-md-8 d-flex align-items-stretch">
                {this.renderInfoBox('O sistema não permite seguir com valor inferior a R$ 7,00.')}
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-8">
              <div className="vx-modal-section" style={{ height: '100%' }}>
                <div className="vx-modal-section-title">
                  <i className="material-icons">credit_card</i> Formas de pagamento
                </div>
                <p className="text-muted" style={{ fontSize: 12, marginTop: -6 }}>
                  Exibe apenas as formas de pagamento cadastradas para a empresa e para o usuário. É possível dividir o pagamento entre mais de uma forma.
                </p>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10 }}>
                  {FORMAS_PAGAMENTO.filter(forma => !this.formaPagamentoDesabilitada(forma.codigo)).map(forma => {
                    const selecionado = this.state.formasPagamentoSelecionadas.includes(forma.codigo)
                    return (
                      <div key={forma.codigo}
                           onClick={() => this.togglePagamento(forma.codigo)}
                           style={{
                             display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer',
                             border: `1.5px solid ${selecionado ? forma.hex : '#e5e5e5'}`,
                             borderRadius: 24, padding: '6px 16px 6px 8px',
                             background: selecionado ? `${forma.hex}12` : '#fff'
                           }}>
                        <input type="checkbox" checked={selecionado}
                               onChange={() => this.togglePagamento(forma.codigo)}
                               style={{ accentColor: forma.hex, width: 16, height: 16 }}/>
                        <div className={`vx-action-icon-wrap c-${forma.cor}`} style={{ width: 26, height: 26 }}>
                          <i className="material-icons" style={{ fontSize: 14 }}>{forma.icone}</i>
                        </div>
                        <span style={{ fontSize: 12, fontWeight: 600, color: '#555' }}>{forma.label}</span>
                      </div>
                    )
                  })}
                </div>

                {formasSelecionadasInfo.length > 0 && (
                  <div className="form-row mt-3">
                    {formasSelecionadasInfo.map(forma => (
                      <div className="col-md-4" key={forma.codigo} style={{ marginBottom: 8 }}>
                        <label>Valor em {forma.label}</label>
                        <CurrencyInput
                          prefix="R$" decimalSeparator=","
                          className="form-control"
                          thousandSeparator="."
                          value={this.state.valoresPorForma[forma.codigo] || ''}
                          onChange={valorFormatado => this.atualizarValorForma(forma.codigo, valorFormatado)}
                        />
                      </div>
                    ))}
                  </div>
                )}

                {formasSelecionadasInfo.filter(f => FORMAS_COM_COMPROVANTE.includes(f.codigo)).map(forma => {
                  const comprovante = this.state.comprovantesPorForma[forma.codigo] || {}
                  return (
                    <div className="form-row mt-2" key={`comprovante-${forma.codigo}`}>
                      <div className={FORMAS_COM_PARCELAS.includes(forma.codigo) ? 'col-md-4' : 'col-md-6'}>
                        <label>Número comprovante {forma.label}</label>
                        <input type="text" className="form-control"
                               value={comprovante.numeroComprovante || ''}
                               onChange={event => this.atualizarComprovanteCampo(forma.codigo, 'numeroComprovante', event.target.value)}/>
                      </div>
                      {FORMAS_COM_PARCELAS.includes(forma.codigo) && (
                        <div className="col-md-4">
                          <label>Quantidade de parcelas</label>
                          <input type="number" min="1" className="form-control"
                                 value={comprovante.quantidadeParcelas || ''}
                                 onChange={event => this.atualizarComprovanteCampo(forma.codigo, 'quantidadeParcelas', event.target.value)}/>
                        </div>
                      )}
                      <div className={FORMAS_COM_PARCELAS.includes(forma.codigo) ? 'col-md-4' : 'col-md-6'}>
                        <label>&nbsp;</label>
                        {comprovante.base64Comprovante ? (
                          <div className="d-flex align-items-center">
                            <span className="mr-2" style={{ fontSize: 13 }}>{comprovante.nomeComprovante}</span>
                            <button type="button" className="btn btn-editar" title="Remover"
                                    onClick={() => this.removerComprovante(forma.codigo)}>
                              <i className="material-icons" style={{ color: 'red' }}>close</i>
                            </button>
                          </div>
                        ) : (
                          <div className="input-wrapper">
                            <label className="btn-laranja" htmlFor={`input-comprovante-${forma.codigo}`} style={{ marginBottom: 0 }}>
                              <div className="row align-items-center">
                                <i className="material-icons">attach_file</i>
                                <strong className="ml-2">Anexar comprovante</strong>
                              </div>
                            </label>
                            <input id={`input-comprovante-${forma.codigo}`} type="file" accept="image/png,image/jpeg,application/pdf"
                                   onChange={event => this.handleAnexarComprovante(event, forma.codigo)} style={{ display: 'none' }}/>
                          </div>
                        )}
                      </div>
                    </div>
                  )
                })}

                {nenhumaFormaSelecionada && (
                  <small className="text-danger d-block mt-2">Selecione pelo menos uma forma de pagamento.</small>
                )}
                {somaDivergente && (
                  <small className="text-danger d-block mt-2">
                    A soma das formas de pagamento (R$ {somaFormasPagamento.toFixed(2).replace('.', ',')}) deve ser igual ao valor da reserva.
                  </small>
                )}
                {this.state.erros.formaPagamento && <small className="text-danger d-block mt-2">{this.state.erros.formaPagamento}</small>}
              </div>
            </div>
            <div className="col-md-4">
              <div className="vx-modal-section" style={{ height: '100%', background: '#fff8f3' }}>
                <div className="vx-modal-section-title">
                  <i className="material-icons">receipt</i> Resumo da venda
                </div>
                <div className="vx-info-item mb-2">
                  <div className="vx-info-item-label">Itinerário</div>
                  <div className="vx-info-item-value">
                    {this.state.itinerarioSelecionado ? `#${this.state.itinerarioSelecionado.id}` : '-'}
                  </div>
                </div>
                <div className="vx-info-item mb-2">
                  <div className="vx-info-item-label">Trecho urbano</div>
                  <div className="vx-info-item-value">
                    {this.state.cidadeOrigem && this.state.cidadeDestino
                      ? `${this.state.cidadeOrigem.nome} → ${this.state.cidadeDestino.nome}`
                      : '-'}
                  </div>
                </div>
                <div className="vx-info-item mb-2">
                  <div className="vx-info-item-label">Valor</div>
                  <div className="vx-info-item-value" style={{ color: '#FF6A00', fontWeight: 700 }}>
                    {this.state.valor || '-'}
                  </div>
                </div>
                <div className="vx-info-item">
                  <div className="vx-info-item-label">Pagamento</div>
                  <div className="vx-info-item-value">
                    {formasSelecionadasInfo.length > 0 ? formasSelecionadasInfo.map(f => f.label).join(' + ') : '-'}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {this.state.erroSalvar && <div className="alert alert-danger" role="alert">{this.state.erroSalvar}</div>}

          <div className="vx-footer-actions">
            <div className="vx-footer-left">
              <button className="vx-btn-secondary" onClick={() => this.novaVenda()}>Limpar</button>
            </div>
            <div className="vx-footer-right">
              <button className="vx-btn-primary" disabled={this.state.salvando || somaDivergente} onClick={() => this.finalizarVenda()}>
                {this.state.salvando ? 'Salvando...' : 'Cadastrar venda urbana'}
                {!this.state.salvando && <i className="material-icons">check</i>}
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  empresaSelecionada: state.empresaSelecionada,
  itinerariosAbertosVendaUrbana: state.itinerariosAbertosVendaUrbana,
  pagamentosDesativados: state.pagamentosDesativados,
  pagamentosDesativadosUsuario: state.pagamentosDesativadosUsuario
})

export default connect(mapStateToProps, {
  buscarItinerariosAbertosVendaUrbana,
  cadastrarVendaUrbana,
  buscarVendaUrbanaPorId,
  buscarCidadesPorNome,
  recuperarFormaPagamentosDesativados,
  recuperarPagamentosDesativadosUsuario
})(PainelCadastroVendaUrbana)
